module.exports = __webpack_public_path__ + "static/christyatstove2-f9cf233fde335f81d59f1c6d7818e4be.jpg";